import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit, Inject } from '@angular/core';
import { Constants } from '@utils/constants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { AuthenticationService } from '@services/authentication.service';
import { Signature } from '@model/signature.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-signature',
  templateUrl: './modal-signature.component.html'
})
export class ModalSignatureComponent implements OnInit {

  public model: Signature = new Signature();

  public loadingforgot = false;
  public showConfirm = false;
  public showError = false;
  public helpPhone1: any;
  public helpEmail: string;

  public loading: any;
  public user: any;
  public isUserLogged: any;

  public titleError = Constants.MSG01_FORGOT_SIGNATURE_TITLE_ERROR;
  public contentError = Constants.MSG01_FORGOT_SIGNATURE_CONTENT_ERROR;
  public titleConfirm = Constants.MSG01_FORGOT_SIGNATURE_TITLE_CONFIRM;
  public contentConfirm = Constants.MSG01_FORGOT_SIGNATURE_CONTENT_CONFIRM;
  public titleRecover = Constants.MSG01_FORGOT_SIGNATURE_TITLE;
  public contentRecover = Constants.MSG01_FORGOT_SIGNATURE_CONTENT;

  constructor(
    public dialogRef: MatDialogRef<ModalSignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _configService: ConfigService,
    public _notificationService: NotificationsService,
    private _authenticationService: AuthenticationService,
  ) {
    this.data.email = this._configService.getHbEmail();
  }

  ngOnInit() {
    this.getContact();
  }

  getContact() {
    const organization = Constants.WHITELABEL.find(org => org.system.cod == environment.WHITELABEL)
    if (organization) {
      this.helpPhone1 = organization.contact.supportPhone;
      this.helpEmail = organization.contact.email;
    }
  }

  goBack() {
    this.showError = false;
    this.showConfirm = false;
  }

  closeClick(): void {
    this.dialogRef.close(false);
  }

  openWhatsappWindow() {
    if (this.helpPhone1.isWhatsApp) {
      window.open(Constants.SIDEBAR_HELP_WHATSAPP_LINK + this.helpPhone1.phoneNumber);
    }
  }

  send() {
    this.loadingforgot = true;
    if (!this.data.email) {
      this._notificationService.warn('', Constants.MSG04_SIGNATURE_ERROR);
      this.loadingforgot = false;
      return;
    }
    this._authenticationService.forgotSignature(this.data.email)
      .subscribe(res => {
        if (res && (res.success === 'true' || res.success === true || res.data.status === 202)) {
          this.model = new Signature();
          this.showConfirm = true;
        } else {
          if (res && res.message) {
            this._notificationService.error('', res.message);
          } else {
            this._notificationService.error('', Constants.MSG_LOGIN_MSG003);
          }
          this.showError = true;
        }
        this.loadingforgot = false;
      }, error => {
        this._notificationService.error('', Constants.MSG_LOGIN_MSG003);
        this.loadingforgot = false;
        this.showError = true;
      });
  }

}
